module.exports = __webpack_public_path__ + "static/greyknitcardi-bd7520dfe99ed6155ebc96167a9b730f.jpeg";